import React, { Component } from "react";
import { connect } from "react-redux";
import AddTracks from "../AddTracks/AddTracks";
import { immediateToast } from "izitoast-react";

import { callAPI } from "../../assets/Js/backendCommunication";

import projectSettings from "../../assets/Js/projectSettings";

import { getPlainToken } from "../../assets/Js/tokenHandler";

import trackChanged from "../../redux/actionCreators/trackChanged";

import { closeModel } from "../../assets/Js/closeModel";

import { apiResponseToast } from "../../assets/Js/apiResponseToast";

const mapStateToProps = (state) => {
  return {
    gymData: state.gymData,
    userData: state.userData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    trackDeleted: () => dispatch(trackChanged()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  class MyTracks extends Component {
    constructor(props) {
      super(props);

      this.state = {
        tracks: [],
        isLoading: false,
        options: [],
        selectedGym: {},
        gymData: {},
        addTracksChange: false,
      };
    }

    componentDidMount() {
      if (this.props && this.props.gymData.length) {
        this.getGym();
      }
    }

    static getDerivedStateFromProps(newProps, prevProps) {
      return {
        ...prevProps,
        gymData: newProps.gymData,
      };
    }

    componentDidUpdate(prevProps, prevState) {
      if (
        prevProps.gymData !== this.props.gymData ||
        prevProps.gymId !== this.props.gymId
      ) {
        this.getGym();
      }
    }

    getGym = () => {
      if (this.props.gymData) {
        let gym = this.props.gymData.find(
          (item) => item.Id === this.props.gymId
        );
        this.setState({
          gymData: gym,
          tracks: gym ? gym.Tracks : [],
        });
      }
    };

    getTrack = (track) => {
      this.setState({
        tracks: this.props.gymData[track.value].Tracks,
        selectedGym: this.props.gymData[track.value],
      });
    };

    deleteTrackRequest = async (trackId) => {
      let url =
        this.props && this.props.userData.Role === "athlete"
          ? `${projectSettings.baseUrl}/tracks/unassign`
          : `${projectSettings.baseUrl}/tracks/delete/${trackId}`;
      let header = true;
      let type = "POST";
      let token = getPlainToken();
      let data =
        this.props && this.props.userData.Role === "athlete"
          ? JSON.stringify({
              trackId,
              userId: this.props.userData.Id,
            })
          : null;

      let response = "";

      if (response === "") {
        this.setState({ isLoading: true });
      }

      response = await callAPI(url, header, type, data, token);

      if (response) {
        apiResponseToast(response.status, "removeTrack");

        this.setState({ isLoading: false });
        if (response.type === "error") {
        } else if (response.type === "success") {
          this.props.trackDeleted();
          this.props.resetOnCloseModal();
          closeModel(this.props.modalId);

          response = "";
        }
      }
    };

    editTrack = (track) => {
      this.props.editTrackInfo(false, track);
      return;
    };

    removeTrack = (id) => {
      new Promise((resolve) => {
        immediateToast("question", {
          timeout: 20000,
          close: false,
          overlay: true,
          displayMode: "once",
          id: "question",
          zindex: 9999,
          title: "Delete Request",
          message: "Are you sure about that?",
          position: "center",
          buttons: [
            [
              `<button><b>YES</b></button>`,
              function (instance, toast) {
                instance.hide({ transitionOut: "fadeOut" }, toast, "button");

                resolve("yes");
              },
              true,
            ],
            [
              `<button>NO</button>`,
              function (instance, toast) {
                instance.hide({ transitionOut: "fadeOut" }, toast, "button");
              },
            ],
          ],
        });
      })
        .then((responce) => {
          this.deleteTrackRequest(id);
        })
        .catch((err) => console.error("error:", err));
    };

    render() {
      return (
        <div className="dashboardTableSection">
          {this.state.addTracksChange && (
            <button
              className="basicBtnStyle primaryBtn mb-2"
              onClick={() => {
                this.setState({ addTracksChange: false });
              }}
            >
              <i className="mdi mdi-arrow-left mr-2"></i>
              Back
            </button>
          )}
          {!this.state.addTracksChange ? (
            <div className="table-responsive mt-2">
              {this.state.tracks.length ? (
                <table className="table table-striped text-center">
                  <thead>
                    <tr className="rounded-top pt-2 pb-2">
                      <th>Name</th>
                      <th>Price</th>
                      <th>Type</th>
                      <th>Password</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody className="primaryScrollBar tertiaryScrollBar">
                    {!this.state.tracks.length
                      ? null
                      : this.state.tracks.map((currVal, index) => (
                          <tr key={index}>
                            <td>{currVal.Name}</td>
                            <td>{currVal.Price}</td>
                            <td>{currVal.Type}</td>
                            <td>{currVal.JoinPassword}</td>

                            <td>
                              {this.props.userData.Role === "owner" && (
                                <span
                                  className="pointerCursor border-right border-dark pr-2"
                                  onClick={(index) => {
                                    this.editTrack(currVal);
                                  }}
                                  data-target="#editTrack"
                                >
                                  Edit
                                </span>
                              )}
                              <a
                                className="pointerCursor"
                                onClick={(index) => {
                                  this.removeTrack(currVal.Id);
                                }}
                              >
                                {" "}
                                Remove
                              </a>
                            </td>
                          </tr>
                        ))}
                  </tbody>
                </table>
              ) : (
                <div className="mt-4 mb-4  mx-auto w-25">
                  <span>No Tracks Found</span>
                </div>
              )}
            </div>
          ) : (
            <AddTracks
              gymData={this.state.gymData}
              modalId={this.props.modalId}
              editableTrack={false}
            />
          )}
          <div className="float-right width-fit-content mx-auto mt-3">
            <button
              className={`basicFatBtnStyle quaternaryColor colorDark mr-2`}
              data-dismiss="modal"
              onClick={this.props.resetOnCloseModal}
            >
              Cancel
            </button>

            {this.props.userData.Role === "owner" &&
              !this.state.addTracksChange && (
                <button
                  className="basicFatBtnStyle primaryBtn"
                  onClick={() => {
                    this.setState({ addTracksChange: false });
                    this.props.addTrackOpened();
                  }}
                >
                  <i className="mdi mdi-plus menu-icon colorWhite"></i>
                  Add Tracks
                </button>
              )}
          </div>
        </div>
      );
    }
  }
);
